import React, { ChangeEvent, useState } from "react";
import { TextInputProp } from "./types";

import Label from "../Label/Label";
import ErrorText from "../ErrorText/ErrorText";

import "./styles.scss";

const TextInput = ({
  label,
  required,
  defaultValue = "",
  onChange,
  error,
  disabled,
  onBlur = () => {},
  showLabel = true,
  placeholder = "",
}: TextInputProp): JSX.Element => {
  const [inputValue, setInputValue] = useState(defaultValue);

  const onInputChange = (e: ChangeEvent<HTMLInputElement>): void => {
    e.stopPropagation();
    const value = e.target.value;
    setInputValue(value);
    if (onChange) {
      onChange(value);
    }
  };

  return (
    <div className="text-input-container">
      {showLabel ? <Label required={required} label={label} /> : null}
      <input
        placeholder={placeholder}
        disabled={disabled}
        autoComplete="off"
        value={inputValue}
        onChange={onInputChange}
        onBlur={({ target }) => onBlur(target?.value)}
      />
      {error ? <ErrorText error={error} /> : null}
    </div>
  );
};

export default TextInput;
